import useAccess from '@/composables/access/access';
import { computed } from 'vue';
import { experimentFlag } from 'shared/experiments.json';
import { featureFlag } from 'shared/constants.json';

export default function useAIChat() {
  const { accountHasFeature } = useAccess();

  const canUseAIChat = computed(() => accountHasFeature([featureFlag.aiChat]));
  const canPickModel = computed(() => accountHasFeature([experimentFlag.aiChatPilot]));

  return { canUseAIChat, canPickModel };
}
